// @flow
import type {SsoUserCloseForgotPasswordEmailModalAction, SsoUserOpenForgotPasswordEmailModalAction} from "../ssoUserSendForgotPasswordAction";

/**
 * Created by Mike Chung on 2/13/18.
 */

export function openSsoUserSendForgotPasswordEmailModalAction(ssoUid: string): SsoUserOpenForgotPasswordEmailModalAction {
    return {
        type: "sso/SHOW_FP_EMAIL_MODAL_ACTION",
        ssoUid: "" + ssoUid
    }
}

export function closeSsoUserSendForgotPasswordEmailModalAction(): SsoUserCloseForgotPasswordEmailModalAction {
    return {
        type: "sso/HIDE_FP_EMAIL_MODAL_ACTION"
    }
}



// WEBPACK FOOTER //
// ./src/actions/modal/creators/ssoUserSendForgotPasswordActionCreator.js